/**
 * General admin scripts
 */
(function($) {
	const cdSettings                = '.cd-settings';
	const socialReveal              = `.social-url-reveal`;
	const mediaSelect               = `.cd-wp-media-select`;
	const openClass                 = 'is-open';
	
	let changeLabelOnUpload         = true;

	function cdMediaSelect( $container ) {
		let frame;
		let $imageContainer     = $container.find(`${mediaSelect}__image`);
		let $image              = $container.find(`${mediaSelect}__image img`);
		let $remove             = $container.find(`${mediaSelect}__remove`);
		let $input              = $container.find(`${mediaSelect}__input`);
		let $button             = $container.find(`${mediaSelect}__add`);
		
		if ( frame ) {
			frame.open();
			return;
		}

		// Create a new media frame
		frame = wp.media({
			title: 'Select or Upload New Image',
			button: {
				text: 'Use this media'
			},
			multiple: false  // Set to true to allow multiple files to be selected
		});
		// When an image is selected in the media frame...
		frame.on( 'select', function() {
			// Get media attachment details from the frame state
			var attachment  = frame.state().get('selection').first().toJSON();
	
			// Send the attachment URL to our custom image input field.
			$image.remove(); // clear it first
			$remove.addClass('is-visible');
			
			if( attachment.mime === 'application/pdf' ) {
				$imageContainer.addClass('is-pdf');
				$imageContainer.append( `<img src="/wp-includes/images/media/document.png" alt="" />` );
				$imageContainer.append( `<div class="cd-wp-media-select__filename">${attachment.filename}</div>` );
			} else {
				$imageContainer.removeClass('is-pdf');
				$imageContainer.append( `<img src="${attachment.url}" alt="" style="max-width:100%;"/>` );
			}

			// Send the attachment id to our hidden input
			$input.val( attachment.id );

			if( changeLabelOnUpload ) {
				let alternateLabel = $button.attr('data-alternate-label');
				let currentLabel = $button.html();
				$button.attr('data-alternate-label', currentLabel);
				$button.html( alternateLabel );
				changeLabelOnUpload = false;
			}
		});

		// Finally, open the modal on click
		frame.open();
	}
	
	$(document).ready(function() {
		if( $(`${mediaSelect}__remove`).hasClass('is-visible') ) changeLabelOnUpload = false;
		
		$(socialReveal).each(function() {
			let $reveal             = $(this);
			let dataReveal          = $reveal.attr('data-reveal');
			let $revealUrlInput     = $(`input[data-reveal="${dataReveal}"]`);
			let $revealUrl          = $revealUrlInput.closest('.social-url');

			if( $reveal.prop('checked') ) {
				$revealUrl.addClass(openClass);
			}
			
			$reveal.on('change', function() {
				let isChecked   = $(this).prop('checked');
				console.log($revealUrl);
				if( isChecked ) {
					$revealUrl.addClass(openClass);
				} else {
					$revealUrl.removeClass(openClass);
				}
			});
		});
		
		if( $(mediaSelect).length ) {
			$(`${mediaSelect}__add`).on('click', function(event) {
				event.preventDefault();
				let $container = $(this).closest(mediaSelect);
				cdMediaSelect($container);
			});
			
			$(`${mediaSelect}__remove`).on('click', function(event) {
				event.preventDefault();
				$(this).removeClass('is-visible');
				let $button             = $(`${mediaSelect}__add`);
				let alternateLabel      = $button.attr('data-alternate-label');
				let currentLabel        = $button.html();
				$button.attr('data-alternate-label', currentLabel);
				$button.html( alternateLabel );
				
				let $container          = $(this).closest(mediaSelect);
				$container.find(`${mediaSelect}__image`).removeClass('is-pdf');
				$container.find(`${mediaSelect}__image img`).remove();
				$container.find(`${mediaSelect}__filename`).remove();
				$container.find(`${mediaSelect}__input`).val( -1 );
				
				changeLabelOnUpload = true;
			});
		}
	});
})(jQuery);